﻿import { ISchedule } from "@/interfaces";

const FALLBACK_SCHEDULE_INDEX = 0;

export const getDefaultSchedule = (
  schedules: ISchedule[] | undefined,
  currentScheduleId: string | undefined
): ISchedule | undefined => {
  if (!schedules?.length) return;

  const currentSchedule = schedules.find(({ id }) => id === currentScheduleId);

  if (currentSchedule) return;

  return schedules[FALLBACK_SCHEDULE_INDEX];
};
